<template>
  <BaseModal
    name="confirm-affiliation"
    size="md"
    :title="$t('seller.affiliation.modals.confirm_affiliation.text_109')"
    @hidden="reset"
    @shown="openModal"
  >
    <p class="informativo" v-if="!comentario">
      {{ $t('seller.affiliation.modals.confirm_affiliation.text_110') }}
    </p>
    <ul class="termos" v-if="!comentario">
      <li>
        <span>01.</span>
        <p>
          {{ $t('seller.affiliation.modals.confirm_affiliation.text_111') }}
        </p>
      </li>
      <li>
        <span>02.</span>
        <p>
          {{ $t('seller.affiliation.modals.confirm_affiliation.text_112') }}
        </p>
      </li>
      <li>
        <span>03.</span>
        <p>
          {{ $t('seller.affiliation.modals.confirm_affiliation.text_113') }}
        </p>
      </li>
    </ul>

    <div v-if="comentario" data-anima="top">
      <b-form-group
        :label="$t('seller.affiliation.modals.confirm_affiliation.text_114')"
        label-for="observation"
      >
        <b-form-textarea
          id="observation"
          :placeholder="$t('seller.affiliation.modals.confirm_affiliation.text_114')"
          name="observation"
          v-model="observation"
          v-validate="'required'"
        ></b-form-textarea>
        <b-form-invalid-feedback :state="!errors.has('observation')">
          {{ $t('seller.affiliation.modals.confirm_affiliation.text_1650') }}
        </b-form-invalid-feedback>
      </b-form-group>
    </div>
    <template v-slot:footer="{}">
      <div class="botoes">
        <BaseButton
          variant="info"
          class="criar-conta"
          @click="openRegister"
          v-if="!logado"
        >
          {{ $t('seller.affiliation.modals.confirm_affiliation.text_1651') }}
        </BaseButton>
        <BaseButton
          variant="secondary_outline"
          class="entrar-conta"
          @click="openLogin"
          v-if="!logado"
        >
          {{ $t('seller.affiliation.modals.confirm_affiliation.text_1652') }}
        </BaseButton>
        <BaseButton
          variant="secondary_outline"
          class="entrar-conta"
          :disabled="loading"
          @click="validateAccept"
          v-if="logado"
        >
          {{ $t('seller.affiliation.modals.confirm_affiliation.text_115') }}
        </BaseButton>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import Utils from "@/mixins/utils";
import AffiliateService from "@/services/resources/AffiliateService";
import Cookies from "js-cookie";

const serviceAffiliate = AffiliateService.build();

export default {
  name: "ConfirmAffiliation",
  mixins: [Utils],
  data() {
    return {
      aprovacao_component: 0,
      loading: false,
      comentario: false,
      observation: "",
      logado: Cookies.get("access_token"),
    };
  },
  props: {
    hash_afiliado: {
      type: String,
      default: "",
    },
    product_id: {
      type: Number,
      default: -1,
    },
    product_name: {
      type: String,
      default: "",
    },
    aprovacao: {
      type: Number,
      default: -1,
    },
    manager: {
      type: String,
      default: "",
    },
  },
  methods: {
    reset() {
      this.comentario = false;
      this.observation = "";
      this.aprovacao_component = 0;
    },
    openModal() {
      console.log(this.aprovacao);
      this.aprovacao_component = this.aprovacao;
    },
    openRegister() {
      const query = this.$route.query;
      query.hash_a = this.hash_afiliado;
      this.$router.push({
        name: "Seller-Register",
        query: query,
      });
    },
    openLogin() {
      this.$router.push(
        `/?hash_a=${this.hash_afiliado}&p_id=${this.product_id}&manager=${this.manager}`
      );
    },
    validateAccept() {
      if (this.aprovacao_component) {
        this.comentario = true;
        this.aprovacao_component = 0;
      } else {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.acceptInvite();
          }
        });
      }
    },
    acceptInvite() {
      this.loading = true;
      let data = {
        hash: this.hash_afiliado,
        url: "accept-invite",
      };

      if (this.manager) {
        data.manager = this.manager;
      }
      if (this.aprovacao) {
        data.observation = this.observation;
      }

      serviceAffiliate
        .search(data)
        .then(() => {
          // validação
          if (!this.aprovacao) {
            this.getAffiliation(this.product_id);
          } else {
            this.$emit("close");
            this.$bvToast.toast(
              this.$t('seller.affiliation.modals.confirm_affiliation.text_1653'),
              {
                title: this.$t('seller.affiliation.modals.confirm_affiliation.text_1654'),
                variant: "info",
                autoHideDelay: 9000,
                noAutoHide: true,
                appendToast: true,
              }
            );
          }
        })
        .catch((err) => {
          console.log(err);
          const r = err.response;
          if (r) {
            this.$bvToast.toast(
              this.this.$t('seller.affiliation.modals.confirm_affiliation.text_116'),
              {
                title: this.this.$t('seller.affiliation.modals.confirm_affiliation.text_1654'),
                variant: "danger",
                autoHideDelay: 5000,
                appendToast: true,
              }
            );
          }
        })
        .finally(() => {
          this.loading = false;
          this.$bvModal.hide("confirm-affiliation");
        });
    },
    getAffiliation(id_product) {
      let data = {
        id: `${this.userID}/${id_product}`,
      };

      serviceAffiliate
        .read(data)
        .then((resp) => {
          this.$router.push(
            `/links/?affiliation_id=${resp.id}&p_name=${this.product_name}&comingAffiliate=true`
          );
        })
        .catch((err) => {
          this.$router.push(`/links/?comingAffiliate=true`);
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
p {
  color: #81858e;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.5;
  margin: 0;
}
.informativo {
  color: #333333;
  font-size: 15px;
  font-weight: 600;
  /* max-width: 80%; */
}
.termos {
  margin: 30px 0 20px 0;
  /* max-width: 80%; */
}
.termos li {
  display: flex;
  align-items: flex-start;
  gap: 15px;
}
.termos li + li {
  margin-top: 20px;
}
.termos li span {
  font-weight: 600;
  font-size: 15px;
  color: #2a63ab;
}
.botoes {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
}

.criar-conta,
.entrar-conta {
  flex: 1;
}
.criar-conta {
  color: #2a63ab;
  background: rgba(33, 51, 210, 0.1);
  border: none;
}
#observation {
  resize: none !important;
  height: 15vh !important;
}
</style>
